<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <p-card>
    <div class="p-fluid lk-eu-mobile-form-fields">
      <div class="field">
        <label class="font-medium">Клиент</label>
        <crm-client-auto-complete
          [isError]="$any(errors?.client)"
          [(selectedClient)]="task.client"
          (selectedClientChange)="selectedClient()"
          [showClear]="true"
          [customSearch]="false"
          appendTo="body"></crm-client-auto-complete>
        <small
          *ngIf="errors?.client"
          class="p-error">
          {{ errors.client | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium required-field">Дата проезда</label>
        <crm-datepicker
          [(value)]="task.date"
          [inputStyleClass]="errors?.date ? 'ng-invalid ng-dirty' : ''"
          appendTo="body"></crm-datepicker>
        <small
          *ngIf="errors?.date"
          class="p-error">
          {{ errors?.date | join }}
        </small>
      </div>

      <p-messages
        *ngIf="!(form$ | async)?.isShowDelete"
        severity="info">
        <ng-template pTemplate="">
          <div class="flex gap-2 align-items-center">
            <i
              class="pi pi-exclamation-circle"
              style="font-size: 1.3rem"></i>
            <ul [style.padding-inline-start.px]="20">
              <li>Введите только регистрационный номер транспортного средства</li>
              <li>Пример: А001МР97</li>
            </ul>
          </div>
        </ng-template>
      </p-messages>

      <div class="field">
        <label class="font-medium required-field">Гос. номер ТС</label>
        <crm-input-text
          [(value)]="task.carNumber"
          [isError]="$any(errors?.carNumber)"></crm-input-text>
        <small
          *ngIf="errors?.carNumber"
          class="p-error">
          {{ errors.carNumber | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium required-field">Помещения</label>
        <crm-room-multi-select
          [isError]="$any(errors?.rooms)"
          [(selectedRooms)]="task.rooms"
          [isFloatLabel]="false"
          [onlyWithHikvisionCameras]="true"
          [autoSelectOne]="true"
          (selectedRoomsChange)="onRoomsChange($event)"
          appendTo="body">
        </crm-room-multi-select>
        <small
          *ngIf="errors?.rooms"
          class="p-error">
          {{ errors.rooms | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium required-field">Категория ТС</label>
        <crm-car-category-single-select
          [roomIds]="selectedRoomsIds"
          [disabled]="!task?.rooms?.length"
          [isError]="$any(errors?.category)"
          [(selectedCategory)]="task.category"
          [placeholder]="!task?.rooms?.length ? 'Выберите помещения' : '\u00A0'"
          appendTo="body">
        </crm-car-category-single-select>
        <small
          *ngIf="errors?.category"
          class="p-error">
          {{ errors.category | join }}
        </small>
      </div>
    </div>
  </p-card>

  <p-card
    header="Участники"
    styleClass="mt-3">
    <div class="p-fluid">
      <div class="field">
        <label class="font-medium">Ответственный</label>
          <crm-user-single-select
            [(selectedUser)]="task.responsible"
            [isError]="$any(errors?.responsible)"
            appendTo="body"></crm-user-single-select>
        <small
          *ngIf="errors?.responsible"
          class="p-error">
          {{ errors.responsible | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium">Внешний пользователь</label>
        <div class="flex align-items-center gap-1">
          <div class="flex-grow-1">
            <crm-external-user-single-select
              #externalUserSingleSelectComponent
              [(selectedEntity)]="task.externalUser"
              [clientIds]="task.client?.id ? [task.client.id] : null"
              [requireFilter]="true"
              [isError]="$any(errors?.externalUser)"
              [disabled]="!task.client?.contragents?.length"
              appendTo="body"></crm-external-user-single-select>
          </div>
          <crm-button
            *ngIf="task.client?.id && task.client?.contragents?.length"
            icon="pi pi-plus"
            (onClick)="openFormCreateExternalUser()"></crm-button>
        </div>
        <small
          *ngIf="errors?.externalUser"
          class="p-error">
          {{ errors.externalUser | join }}
        </small>
      </div>

      <h3 class="font-medium -mb-2">Аудиторы</h3>
      <p-divider></p-divider>
      <div class="formgrid grid">
        <div class="field lg:col-6 col-12">
          <label class="font-medium">Пользователи</label>
            <crm-user-multi-select
              [(selectedUsers)]="task.userAuditors"
              [customRequest]="true"
              [isFloatLabel]="false"
              appendTo="body"></crm-user-multi-select>
        </div>

        <div class="field lg:col-6 col-12">
          <label class="font-medium">Группы</label>
          <crm-user-group-multi-select
            [(selectedUserGroups)]="task.userGroupAuditors"
            [isFloatLabel]="false"
            appendTo="body">
          </crm-user-group-multi-select>
        </div>
      </div>
    </div>
  </p-card>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveTask()"></crm-button>
      <crm-button
        *ngIf="(form$ | async)?.isShowDelete"
        label="Удалить"
        styleClass="p-button-danger p-button-text"
        (onClick)="deleteTask()"></crm-button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
